<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_SUR_STAFF_LIST')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Quản lý nhân viên</h1>
      <div class="float-right btn-group sm-float-none">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          @click="exportFile"
          v-if="dataPermission.includes('CNPS_SUR_STAFF_EXPORT')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-download"></i> Xuất file
        </button>
        <input ref="file" type="file" hidden />

        <button
          @click="importFile"
          v-if="dataPermission.includes('CNPS_SUR_STAFF_IMPORT')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-upload"></i> Nhập file
        </button>

        <button
          @click="$router.push({ path: '/staff-add' })"
          v-if="dataPermission.includes('CNPS_SUR_STAFF_UPSERT')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button>
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              class="form-control f12 hc-37"
              placeholder="Từ khóa"
              v-model.trim="search.keyWord"
            />
          </div>
          <div class="form-group">
            <Select2 placeholder="Vị trí" v-model="search.companyPhase" :options="optionComphase">
            </Select2>
          </div>
          <div class="form-group">
            <Select2 placeholder="Vai trò" v-model="search.typeSale" :options="optionRole">
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              placeholder="Vùng"
              v-model="search.region"
              :options="optionRegion"
              @change="getProvince($event)"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              placeholder="Tỉnh/Thành phố"
              v-model="search.province"
              :options="optionProvince"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2 placeholder="Quản lý" v-model="search.superior" :options="optionSup">
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              placeholder="Trạng thái"
              v-model="search.userStatus"
              :options="optionUserStatus"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              placeholder="Tình trạng cấu hình"
              v-model="search.stateConfig"
              :options="optionUserstateConfig"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              placeholder="Tình trạng cấu hình"
              v-model="search.stateConfig"
              :options="optionUserstateConfig"
            ></Select2>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange1"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian cập nhật
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              placeholder="Cấp bậc nhân viên"
              v-model="search.levelEmployee"
              :options="optionLevelEmployee"
            ></Select2>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange2"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Ngày nghỉ việc
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group form-group-action">
            <button
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng nhân viên: {{ pagination.total }}
            <b-table
              :busy.sync="loading"
              sticky-header
              responsive
              hover
              :items="dataStaff"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(name)="data">
                <b>{{ data.item.name }}</b> <br />
                <div @click="detailStaff(data.item.id)" class="codeStaff">
                  <div v-if="data.item.companyCode">Mã</div>
                  <div class="text">
                    {{ data.item.companyCode }}
                  </div>
                </div>
                <div>
                  <span class="badge badge-success" v-if="data.item.userStatus === 'ACTIVE'"
                    >Đang hoạt động</span
                  >
                  <span class="badge badge-danger" v-else>Đã khóa</span>
                </div>
              </template>
              <template #cell(gender)="data">
                <p v-if="data.item.gender === 'MALE'">Nam</p>
                <p v-else>Nữ</p>
              </template>
              <template #cell(typeSale)="data">
                {{ data.item.typeSale | transfromData(optionRole) }}
              </template>
              <template #cell(companyPhase)="data">
                <p v-if="data.item.companyPhase === 'PROBATION'">Thử việc</p>
                <p v-else>Chính thức</p>
              </template>
              <template #cell(dateWork)="data">
                {{ data.item.companyDayIn
                }}<span v-show="data.item.resignDate">
                  - {{ data.item.resignDate | formatDate }}</span
                >
              </template>
              <template #cell(userKPI)="data">
                <div
                  v-if="
                    data.item.userKPI &&
                    !data.item.userKPI.lead &&
                    !data.item.userKPI.work &&
                    !data.item.userKPI.kpi
                  "
                ></div>
                <div v-else-if="data.item.userKPI" style="white-space: nowrap">
                  <p>
                    Leads/{{ data.item.userKPI.leadUnit | transformData(dataUnit) }} :
                    {{ data.item.userKPI.lead }}
                  </p>
                  <p>
                    Công việc/{{ data.item.userKPI.workUnit | transformData(dataUnit) }} :
                    {{ data.item.userKPI.work }}
                  </p>
                  <p>
                    Số KPI/{{ data.item.userKPI.kpiUnit | transformData(dataUnit) }} :
                    {{ data.item.userKPI.kpi }}
                  </p>
                </div>
              </template>
              <template #cell(isTracking)="data">
                <b-form-checkbox
                  class="text-center"
                  v-model="data.item.isTracking"
                  name="check-button"
                  switch
                  size="lg"
                  disabled
                ></b-form-checkbox>
              </template>
              <template #cell(isTimeKeep)="data">
                <b-form-checkbox
                  class="text-center"
                  v-model="data.item.isTimeKeep"
                  name="check-button"
                  switch
                  size="lg"
                  disabled
                ></b-form-checkbox>
              </template>
              <template #cell(time)="data">
                <span style="white-space: nowrap"
                  >Tạo: {{ data.item.createdTime | formatDate('DD/MM/YYYY HH:mm:ss') }}</span
                ><br />
                <span style="white-space: nowrap"
                  >Cập nhật: {{ data.item.updatedTime | formatDate('DD/MM/YYYY HH:mm:ss') }}</span
                >
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item
                    @click="detailStaff(data.item.id)"
                    class="dropdown-item"
                    v-if="dataPermission && dataPermission.includes('CNPS_SUR_STAFF_DETAIL')"
                  >
                    <i class="bx bx-show-alt"></i><span>&nbsp;</span> Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item
                    class="dropdown-item"
                    data-toggle="modal"
                    v-if="
                      dataPermission.includes('CNPS_SUR_STAFF_RESET_PASSWORD') &&
                      data.item.userStatus === 'ACTIVE'
                    "
                    @click="resetPassword(data.item)"
                    ><i class="bx bx-reset"></i><span>&nbsp;</span>Reset mật khẩu
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="
                      dataPermission &&
                      dataPermission.includes('CNPS_SUR_STAFF_UP_TYPESALE') &&
                      data.item?.typeSale === 'COOPERATOR'
                    "
                    @click="openUpTypeCtvToSale(data.item)"
                    class="dropdown-item"
                  >
                    <i class="bx bx-refresh"></i><span>&nbsp;</span>
                    CTV sang Sale
                  </b-dropdown-item>
                  <b-dropdown-item
                    class="dropdown-item"
                    data-toggle="modal"
                    v-if="
                      dataPermission.includes('CNPS_SUR_STAFF_UPSERT') &&
                      data.item.userStatus === 'ACTIVE'
                    "
                    @click="editStaff(data.item)"
                    ><i class="bx bx-edit-alt"></i><span>&nbsp;</span>Sửa
                  </b-dropdown-item>
                  <b-dropdown-item
                    class="dropdown-item"
                    data-toggle="modal"
                    v-if="
                      ['AFTER_SALE', 'AFTER_SALE_OFFLINE', 'TELESALE'].includes(data.item.typeSale)
                    "
                    @click="openConfigAftersale(data.item)"
                    ><i class="bx bx-edit-alt"></i><span>&nbsp;</span>Cấu hình Aftersale
                  </b-dropdown-item>
                  <b-dropdown-item
                    class="dropdown-item"
                    data-toggle="modal"
                    v-if="
                      dataPermission.includes('CNPS_INTEG_CALLIO_CONFIG') &&
                      data.item.userStatus === 'ACTIVE'
                    "
                    @click="openCallioConfig(data.item)"
                    ><i class="bx bx-edit-alt"></i><span>&nbsp;</span>Cấu hình Callio
                  </b-dropdown-item>
                  <b-dropdown-item
                    class="dropdown-item"
                    data-toggle="modal"
                    v-if="dataPermission.includes('CNPS_SUR_STAFF_SET_STATUS')"
                    @click="lockOrActive(data.item)"
                    ><i class="bx bx-lock-alt"></i><span>&nbsp;</span>
                    <span v-if="data.item.userStatus === 'ACTIVE'">Khóa</span>
                    <span v-else>Mở khóa</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    class="dropdown-item"
                    data-toggle="modal"
                    v-if="dataPermission.includes('ASSIGN') && data.item.userStatus === 'ACTIVE'"
                    @click="assignPermission(data.item)"
                    ><i class="bx bx-lock-alt"></i><span>&nbsp;</span>Gán quyền
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.size"
          class="mr-2 fl-right"
        ></b-pagination>
      </div>
    </div>
    <!-- Modal thông báo -->
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="py-3 f18">{{ msgNoti }}</h2>
        <h6 v-if="passResetNew">Mật khẩu mới: {{ passResetNew }}</h6>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
    <!--Modal reset mật khẩu-->
    <b-modal id="modal-scoped" v-model="resetPassModal">
      <template #modal-header="{ close }">
        <h5>Reset mật khẩu nhân viên</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <h6>Bạn chắc chắn muốn reset mật khẩu nhân viên {{ nameReset }} - {{ emailReset }} ?</h6>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Bỏ qua </b-button>
        <b-button size="sm" variant="primary" @click="confirmReset"> Reset mật khẩu </b-button>
      </template>
    </b-modal>

    <!-- Modal khóa/mở nv-->
    <b-modal id="modal-scoped" v-model="lockModal">
      <template #modal-header="{ close }">
        <h5 v-if="stateStaff === 'ACTIVE'">Khóa nhân viên</h5>
        <h5 v-if="stateStaff === 'INACTIVE'">Mở nhân viên</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <h6 v-if="stateStaff === 'ACTIVE'">
        Bạn chắc chắn muốn khóa nhân viên {{ nameLock }} - {{ emailLock }} ?
      </h6>
      <h6 v-if="stateStaff === 'INACTIVE'">
        Bạn chắc chắn muốn mở khóa nhân viên {{ nameLock }} - {{ emailLock }} ?
      </h6>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Bỏ qua </b-button>
        <b-button size="sm" variant="primary" @click="confirmLockOrActive"> Đồng ý </b-button>
      </template>
    </b-modal>
    <!-- Modal chuyển đổi ctv qua sale-->
    <b-modal id="modal-scoped" v-model="updateTypeModal">
      <template #modal-header="{ close }">
        <h5>Chuyển đổi vai trò từ CTV sang Sale</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div>
        <p class="mt-1">Chọn CTV <span style="color: red">*</span></p>
        <SearchStaffAutocomplete
          v-model="dataUpTypeSale.ctvId"
          placeholder="Chọn cộng tác viên"
          :list="listCtv"
          disabled
        />
        <p class="mt-1">
          Chọn sale <span style="color: red">* </span>
          <span style="color: red" v-if="errorTypeSale">{{ errorTypeSale }}</span>
        </p>
        <SearchStaffAutocomplete
          v-model="dataUpTypeSale.saleId"
          :disabled="isLoadingStaff || listStaff.length === 0 || isDisableTypeSale"
          :list="listStaff"
        />
      </div>

      <template #modal-footer="{ cancel }">
        <b-button
          size="sm"
          variant="light"
          @click="
            cancel()
            dataUpTypeSale = {}
            errorTypeSale = ''
          "
        >
          Huỷ bỏ
        </b-button>
        <b-button v-if="!isDisableTypeSale" size="sm" variant="primary" @click="updateTypeCtv">
          Đồng ý
        </b-button>
      </template>
    </b-modal>
    <!-- Modal gán quyền -->
    <b-modal id="modal-scoped" v-model="assignPermissionModal">
      <template #modal-header="{ close }">
        <h5>Gán quyền</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="modal-body" style="max-height: 500px; overflow-y: auto">
        <h1 class="py-3 f16">
          Nhân viên: {{ nameAssign }}
          <br />
          <span class="badge badge-primary">Mã NV: {{ codeAssign }} </span>
        </h1>
        <li>
          <label class="tree-container">
            Tất cả
            <input type="checkbox" v-model="selectAllRole" />
            <span class="tree-checkmark"></span>
          </label>
        </li>
        <ul class="ql-ganquyen" v-for="(item, index) in dataRole" :key="index">
          <li>
            <label class="tree-container">
              {{ item.name }}
              <input
                type="checkbox"
                @change="changeRole($event, item.name)"
                :value="item.name"
                :checked="checkedRole(item.name)"
              />
              <span class="tree-checkmark"></span>
            </label>
          </li>
        </ul>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Hủy bỏ </b-button>
        <b-button size="sm" variant="primary" @click="confirmAssign"> Lưu </b-button>
      </template>
    </b-modal>
    <callio-config ref="callioConfig" />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <ConfigAftersale
      v-if="showConfigAfs"
      :region="dataConfigAfs.region"
      @updateConfigAfs="updateConfigAfs"
      :idStaff="dataConfigAfs.id"
      @onHidden="onHidden"
      :cityCodes="dataConfigAfs.cityCodes"
      :districtCodes="dataConfigAfs.districtCodes"
      :workAS="dataConfigAfs.workAS"
    />
  </div>
</template>
<script>
  import callioConfig from './callio-config.vue'
  import { StaffService } from '@/services/staff.service'
  import { CommonService } from '@/services/common.service'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import Config from '../../thirdParty/config'
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import ConfigAftersale from './ConfigAftersale.vue'
  import SearchStaffAutocomplete from '@/components/cskh/SearchStaffAutocomplete.vue'
  import { GetUserByType } from '@/services/customer-support/staff'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'name', label: 'Tên', thStyle: 'min-width: 130px' },
    { key: 'userName', label: 'Email' },
    { key: 'mobile', label: 'Số điện thoại' },
    { key: 'gender', label: 'Giới tính' },
    { key: 'typeSale', label: 'Vai trò', thStyle: 'min-width: 90px' },
    { key: 'superiorName', label: 'Quản lý', thStyle: 'min-width: 130px' },
    { key: 'companyPhase', label: 'Vị trí', thStyle: 'min-width: 80px' },
    { key: 'dateWork', label: 'Ngày bắt đầu - Ngày nghỉ việc' },
    { key: 'levelEmployee', label: 'Cấp bậc' },
    { key: 'userKPI', label: 'Tiêu chí KPI' },
    { key: 'province', label: 'Tỉnh/ Thành phố', thStyle: 'min-width: 200px' },
    { key: 'isTracking', label: 'Tracking' },
    { key: 'isTimeKeep', label: 'Chấm công' },
    { key: 'time', label: 'Thời gian' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    mixins: [prepareQueryParamsMixin],
    components: { callioConfig, ConfigAftersale, SearchStaffAutocomplete },
    data() {
      return {
        showLoading: false,
        listStaff: [],
        listCtv: [],
        isLoadingStaff: false,
        loading: false,
        search: {
          size: 50,
          page: 1,
        },
        pagination: {
          total: 0,
        },

        fieldsTable,
        filterTable: fieldsTable,
        dataStaff: [],
        userData: JSON.parse(localStorage.getItem('userData')),
        optionComphase: [{ id: '0', text: 'Tất cả' }, ...Config.optionComphase],
        optionRole: [],
        optionRegion: [],
        optionProvince: [],
        optionSup: [],
        optionUserStatus: Config.optionUserStatus,
        optionUserstateConfig: Config.optionUserstateConfig,
        localeData: Config.localeData,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        dateRange1: {
          startDate: null,
          endDate: null,
        },
        dateRange2: {
          startDate: null,
          endDate: null,
        },
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        passResetNew: '',
        resetPassModal: false,
        nameReset: '',
        emailReset: '',
        staffIdReset: '',
        lockModal: false,
        updateTypeModal: false,
        stateStaff: '',
        nameLock: '',
        emailLock: '',
        assignPermissionModal: false,
        dataRole: [],
        nameAssign: '',
        staffIdAssign: '',
        codeAssign: '',
        roleOfStaff: [],
        dataRoleSelect: [],
        dataUnit: Config.dataUnit,
        optionLevelEmployee: Config.levelEmployee,
        dataConfigAfs: {},
        showConfigAfs: false,
        dataUpTypeSale: { ctvId: '', saleId: '' },
        isDisableTypeSale: false,
        errorTypeSale: '',
      }
    },
    created() {
      this.getDataSearch()
      this.getTypeSale()
      this.getRegions()
      this.getSup()
      this.getRole()
      this.fetchData()
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },

    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return data
        } else {
          return dataReturn[0].text
        }
      },
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        dataSearch: 'search/getDataSearchOther',
      }),
      selectAllRole: {
        get: function () {
          return this.dataRole && this.roleOfStaff
            ? this.roleOfStaff.length === this.dataRole.length
            : false
        },
        set: function (value) {
          var dataRoleSelect = []
          if (value) {
            this.dataRole.forEach(function (item) {
              dataRoleSelect.push(item.name)
            })
          }
          this.roleOfStaff = dataRoleSelect
        },
      },
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
    },
    methods: {
      async openCallioConfig(staff) {
        this.showLoading = true
        await this.$refs.callioConfig.open(staff)
        this.showLoading = false
      },
      openConfigAftersale(data) {
        this.dataConfigAfs = {
          id: data.id,
          region: data.regionName,
          cityCodes: data.cityCodes ? data.cityCodes : [],
          districtCodes: data.districtCodes ? data.districtCodes : [],
          workAS: data.workAS ? data.workAS : '',
        }
        this.showConfigAfs = true
        this.$nextTick(() => {
          this.$bvModal.show('config-aftersale')
        })
      },
      // thêm mới nhân viên
      async addStaff() {
        this.$router.push({ path: '/staff-add' })
      },
      // nhập file
      importFile() {
        this.$router.push({ path: 'staff-import-step-one' })
      },
      async exportFile() {
        try {
          delete this.search.size
          delete this.search.page
          this.search.userIdLogin = this.userData.userId
          this.showLoading = true
          await StaffService.exportStaff(this.search)
        } catch (e) {
          this.error = e.message
          console.log(e)
        } finally {
          this.showLoading = false
        }
      },

      async getTypeSale() {
        try {
          const data = await CommonService.getTypeSale({})
          if (data.success) {
            this.optionRole = data.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
            this.optionRole.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async getRegions() {
        try {
          const data = await StaffService.getRegions()
          if (data.success) {
            this.optionRegion = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.optionRegion.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {}
      },
      async getProvince(e) {
        try {
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            if (this.search.region === '0') {
              this.optionProvince = []
            } else {
              this.optionProvince = data.data.map(e => {
                return { id: e.id, text: e.name }
              })
              this.optionProvince.unshift({ id: 0, text: 'Tất cả' })
            }
          }
        } catch (error) {}
      },
      async getSup() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.userData.userId,
          })
          if (data.success) {
            this.optionSup = data.data.map(e => {
              return {
                id: e.userName,
                text: `${e.name} - ${e.userName}`,
              }
            })
            this.optionSup.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      transformDate() {
        this.search.createdTimeFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.createdTimeTo = moment(this.dateRange.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()

        this.search.updatedTimeFrom = moment(this.dateRange1.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.updatedTimeTo = moment(this.dateRange1.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()

        this.search.dateResignFrom = moment(this.dateRange2.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.dateResignTo = moment(this.dateRange2.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },
      // Lọc
      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        this.fetchData()

        this.$store.commit('search/SET_DATA_SEARCH_OTHER', {
          data: this.search,
          router: this.$router.currentRoute.path,
        })
      },
      // Bỏ lọc
      async removeForm() {
        this.search = {
          size: 50,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dateRange1 = {
          startDate: null,
          endDate: null,
        }
        this.dateRange2 = {
          startDate: null,
          endDate: null,
        }
        this.optionProvince = []
        await this.fetchData()
      },
      // reset password nhân viên
      resetPassword(item) {
        this.resetPassModal = true
        this.nameReset = item.name
        this.emailReset = item.userName
        this.staffIdReset = item.id
      },
      // confirm reset pass
      async confirmReset() {
        this.resetPassModal = false
        try {
          const data = await StaffService.resetPassword({
            userId: this.staffIdReset,
          })
          if (data.success) {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = 'Reset mật khẩu thành công'
            this.passResetNew = data.data.password
          } else {
            this.showFailMx(data.message)
          }
        } catch (error) {
          console.log(error)
        }
      },
      // sửa thông tin nhân viên
      async editStaff(item) {
        this.$router.push({ path: '/staff-edit' + `/?id=${item.id}` })
      },

      lockOrActive(item) {
        this.lockModal = true
        this.staffIdLock = item.id
        this.nameLock = item.name
        this.emailLock = item.userName
        this.stateStaff = item.userStatus
      },
      async confirmLockOrActive() {
        try {
          this.lockModal = false
          if (this.stateStaff === 'ACTIVE') {
            const response = await StaffService.lockOfUnlockStaff({
              userId: this.staffIdLock,
            })
            if (response.success) {
              this.showSuccessMx(response.message)
              this.stateStaff = 'INACTIVE'
            } else {
              this.showFailMx(response.message)
            }
          } else {
            const response = await StaffService.lockOfUnlockStaff({
              userId: this.staffIdLock,
            })
            if (response.success) {
              this.showSuccessMx(response.message)
              this.stateStaff = 'ACTIVE'
            } else {
              this.showFailMx(response.message)
            }
          }
          this.fetchData()
        } catch (error) {
          console.log(error)
        }
      },
      // list role gán quyền
      async getRole() {
        try {
          const data = await CommonService.getAllRole({})
          if (data.success) {
            data.data.map(e => this.dataRole.push({ name: e.name }))
          }
        } catch (error) {
          console.log(error)
        }
      },
      // get Role của NV
      async getRoleByStaff() {
        try {
          const data = await StaffService.getRoleByUser({
            userId: this.staffIdAssign,
          })
          if (data.success) {
            this.roleOfStaff = data.data.roles ? data.data.roles : []
            return
          }
        } catch (error) {
          console.log(error)
        }
      },
      // check xem NV đang có những role gì, khi mở modal hiển thị các role đó dc check
      checkedRole(role) {
        return this.roleOfStaff && this.roleOfStaff.length ? this.roleOfStaff.includes(role) : false
      },
      changeRole(event, role) {
        const checked = event.target.checked
        if (checked) {
          this.roleOfStaff.push(role)
        } else {
          this.roleOfStaff = this.roleOfStaff.filter(e => e !== role)
        }
      },
      // Gán quyền
      async assignPermission(item) {
        this.assignPermissionModal = true
        this.nameAssign = item.name
        this.staffIdAssign = item.id
        this.codeAssign = item.companyCode
        await this.getRoleByStaff()
      },
      async confirmAssign() {
        try {
          const data = await StaffService.setRole({
            roles: this.roleOfStaff,
            userId: this.staffIdAssign,
          })
          if (data.success) {
            this.assignPermissionModal = false
            this.showSuccessMx(data.message)
          } else {
            this.assignPermissionModal = false
            this.showFailMx(data.message)
          }
        } catch (error) {
          console.log(error)
        }
      },
      // dữ liệu bảng
      async fetchData() {
        try {
          for (const key in this.search) {
            if (
              (this.search[key] === '0' ||
                this.search[key] === 'false' ||
                this.search[key] === null) &&
              key !== 'levelEmployee'
            )
              delete this.search[key]
          }

          if (this.search.levelEmployee)
            this.search.levelEmployee = Number(this.search.levelEmployee)
          this.loading = true
          const data = await StaffService.getList(this.search)
          if (data.code === 1000) {
            this.dataStaff = data.data.content
            this.pagination.total = data.data.totalElements ? data.data.totalElements : 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      getDataSearch() {
        if (JSON.stringify(this.dataSearch) === '{}') {
          this.search = {
            size: 50,
            page: 1,
          }
        } else {
          this.search = this.dataSearch
          this.dateRange.startDate = this.search.createdTimeFrom
            ? new Date(this.search.createdTimeFrom).toString()
            : null
          this.dateRange.endDate = this.search.createdTimeTo
            ? new Date(this.search.createdTimeTo).toString()
            : null
          this.dateRange1.startDate = this.search.updatedTimeFrom
            ? new Date(this.search.updatedTimeFrom).toString()
            : null
          this.dateRange1.endDate = this.search.updatedTimeTo
            ? new Date(this.search.updatedTimeTo).toString()
            : null
          this.dateRange2.startDate = this.search.dateResignFrom
            ? new Date(this.search.dateResignFrom).toString()
            : null
          this.dateRange2.endDate = this.search.dateResignTo
            ? new Date(this.search.dateResignTo).toString()
            : null
          if (this.search.region) this.getProvince(this.search.region)
          this.fetchData()
        }
      },
      detailStaff(id) {
        window.open(`staff/detail/?id=${id}`)
      },
      openUpTypeCtvToSale(item) {
        this.updateTypeModal = true
        this.dataUpTypeSale.ctvId = item.id
        this.listCtv.push({
          id: item.id,
          text: `${item.name} - ${item.userName}`,
        })
        if (item?.parentId) {
          this.isDisableTypeSale = true
          this.listStaff = [
            {
              id: item?.parentId,
              text: item?.parentEmail,
            },
          ]
          this.dataUpTypeSale.saleId = item?.parentId
        } else {
          this.getOptionStaff()
          this.isDisableTypeSale = false
        }
      },
      async getOptionStaff() {
        this.isLoadingStaff = true
        try {
          const res = await GetUserByType('SALE')
          if (res.code === 1000) {
            this.listStaff =
              res.data.map(user => {
                return {
                  id: user.id,
                  text: `${user.name} - ${user.email}`,
                }
              }) || []
          } else {
            this.showFailMx(res.message)
          }
        } catch (error) {
          this.showFailMx(error.message)
        } finally {
          this.isLoadingStaff = false
        }
      },
      async updateTypeCtv() {
        if (!this.dataUpTypeSale.saleId) {
          this.errorTypeSale = 'Vui lồng chọn sale'
          return
        }
        try {
          const response = await StaffService.updateTypeSale(this.dataUpTypeSale)
          if (response.code === 1000) {
            this.fetchData()
            this.showSuccessMx('Chuyển đổi thành công!')
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.updateTypeModal = false
        }
      },
      async updateConfigAfs(data) {
        try {
          const response = await StaffService.configAfs(data)
          if (response.success) {
            this.onHidden()
            this.fetchData()
            this.showSuccessMx('Cấu hình thành công!')
          } else {
            this.onHidden()
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        }
      },
      onHidden() {
        this.showConfigAfs = false
        this.$bvModal.hide('config-aftersale')
      },
    },
  }
</script>
<style scoped>
  .codeStaff {
    display: flex;
  }
  .text {
    color: #0a63ab !important;
    margin-left: 3px;
  }
</style>
